import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import FileUpload from "../../components/file-upload";
import GenerateMetrics from "../../components/generate-metrics";
import Modal from "../../components/modal";
import { XIcon, ChevronDownIcon, FilterIcon } from "lucide-react";
import TradeMetrics from "../../components/trade-metrics";
import { finalMockData } from "../../utils/newMockData";
import apiClient from "../../utils/apiClient";
import FileUploadEquity from "./fileUploadEquity";
import FileUploadOptions from "./fileUploadOptions";

export default function PdfToExcel() {
  const [currentTab, setCurrentTab] = useState("equity");
  
  const handleChangeTabs = (tabName) => {
    setCurrentTab(tabName);
  };

  return (
    <DashboardLayout>
      <div className="flex flex-col relative  w-full ">
        <div className=" flex justify-between bg-[#0F0F0F] h-[60px] px-6 w-full">
          <div className="flex space-x-6">
            <div
              onClick={() => handleChangeTabs("equity")}
              className={` ${
                currentTab === "equity"
                  ? "text-[#07F2C7]  border-[#07F2C7]"
                  : "border-transparent"
              } flex items-center border-b-[4px]  text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in    `}
            >
              Equity
            </div>
            <div
              onClick={() => handleChangeTabs("options")}
              className={` ${
                currentTab === "options"
                  ? "text-[#07F2C7]  border-[#07F2C7]"
                  : "border-transparent"
              } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in  `}
            >
              Options
            </div>
          </div>
        </div>

        {currentTab === "equity" && (
          <FileUploadEquity />
        )}

        {currentTab === "options" && (
          <FileUploadOptions />
        )}
      </div>
    </DashboardLayout>
  );
}
